import axios from "axios";

export const envioNuevoPedido = async (entidad) => {


    let data = JSON.stringify(entidad);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        //url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/bf2c6e41-149e-4be4-ae23-35508000632e', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/bf2c6e41-149e-4be4-ae23-35508000632e',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
            console.log(error);
        });


}